import { AppRouteProps } from "@harea/component";
import React from "react";
import { AdminEmployeeCreationRoutes } from "./views/create/AdminEmployeeCreationRoutes";
import { AdminEmployeeImportRoutes } from "./views/import/AdminEmployeeImportRoutes";

const AdminEmployeeListContainer = React.lazy(
    () => import("./container/AdminEmployeeListContainer")
);

export const AdminEmployeeRoutes: Array<AppRouteProps> = [
    {
        path: "employees",
        title: "Harea.Admin.Employee.List.Title",
        element: <AdminEmployeeListContainer />,
        // roles: [""]
        children: [
            ...AdminEmployeeCreationRoutes,
            ...AdminEmployeeImportRoutes
        ]
    },
];
